import { DGAButton } from "components/Shared/dga-button/DGAButton";
import { useEffect, useState } from "react";
import {
  DGA_GRAYSCALE_CHANGE_EVENT,
  getGrayscaleModeEnabled,
  toggleGrayscaleMode,
} from "lib/dgaGrayscaleMode";

export default function GreyScaleAccessToolButton() {
  const [isGrayscale, setIsGrayscale] = useState(false);

  useEffect(() => {
    setIsGrayscale(getGrayscaleModeEnabled());
    const onChange = () => setIsGrayscale(getGrayscaleModeEnabled());
    window.addEventListener(DGA_GRAYSCALE_CHANGE_EVENT, onChange);
    return () => window.removeEventListener(DGA_GRAYSCALE_CHANGE_EVENT, onChange);
  }, []);

  const toggleGrayscale = () => {
    setIsGrayscale(toggleGrayscaleMode());
  };

  return (
    <DGAButton
      variant="secondaryOutline"
      onClick={toggleGrayscale}
      className={isGrayscale ? "!bg-white/20 !border-white" : ""}
      aria-label={isGrayscale ? "Disable grayscale mode" : "Enable grayscale mode"}
      aria-pressed={isGrayscale}
      buttonContent={
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.9974 13.1253C8.27151 13.1253 6.8724 11.7262 6.8724 10.0003C6.8724 8.27444 8.27151 6.87533 9.9974 6.87533C11.7233 6.87533 13.1224 8.27444 13.1224 10.0003C13.1224 11.7262 11.7233 13.1253 9.9974 13.1253ZM8.1224 10.0003C8.1224 11.0359 8.96186 11.8753 9.9974 11.8753C11.0329 11.8753 11.8724 11.0359 11.8724 10.0003C11.8724 8.96479 11.0329 8.12533 9.9974 8.12533C8.96186 8.12533 8.1224 8.96479 8.1224 10.0003Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.9974 3.54199C7.85526 3.54199 6.01902 4.48483 4.59765 5.59448C3.175 6.70512 2.12345 8.01678 1.53524 8.84159L1.49089 8.90344C1.27993 9.19684 1.03906 9.53182 1.03906 10.0003C1.03906 10.4688 1.27993 10.8038 1.49089 11.0972L1.53524 11.1591C2.12345 11.9839 3.175 13.2955 4.59765 14.4062C6.01902 15.5158 7.85526 16.4587 9.9974 16.4587C12.1395 16.4587 13.9758 15.5158 15.3971 14.4062C16.8198 13.2955 17.8713 11.9839 18.4596 11.1591L18.5039 11.0972C18.7149 10.8038 18.9557 10.4688 18.9557 10.0003C18.9557 9.53182 18.7149 9.19684 18.5039 8.90344L18.4596 8.84159C17.8713 8.01678 16.8198 6.70512 15.3971 5.59448C13.9758 4.48483 12.1395 3.54199 9.9974 3.54199ZM2.55295 9.56737C3.10312 8.7959 4.07438 7.58881 5.36686 6.57978C6.66062 5.56975 8.23185 4.79199 9.9974 4.79199C11.7629 4.79199 13.3342 5.56975 14.6279 6.57978C15.9204 7.58881 16.8917 8.7959 17.4418 9.56737C17.5779 9.75822 17.6427 9.85141 17.6813 9.92559C17.7059 9.97275 17.7058 9.98568 17.7057 9.99833L17.7057 10.0003L17.7057 10.0023C17.7058 10.015 17.7059 10.0279 17.6813 10.0751C17.6427 10.1492 17.5779 10.2424 17.4418 10.4333C16.8917 11.2048 15.9204 12.4118 14.6279 13.4209C13.3342 14.4309 11.7629 15.2087 9.9974 15.2087C8.23185 15.2087 6.66063 14.4309 5.36686 13.4209C4.07438 12.4118 3.10312 11.2048 2.55296 10.4333C2.41685 10.2424 2.35208 10.1492 2.31346 10.0751C2.28892 10.0279 2.28899 10.015 2.28906 10.0023L2.28906 10.0003L2.28906 9.99833C2.28899 9.98568 2.28892 9.97275 2.31346 9.92559C2.35208 9.85141 2.41685 9.75822 2.55295 9.56737Z"
            fill="currentColor"
          />
        </svg>
      }
      size="iconOnly md"
    />
  );
}
